import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import React, { FC, useContext } from 'react';

import DiscountCode from '~/components/ShoppingCart/SummaryAndPayment/DiscountCode/DiscountCode';
import { StoreContext } from '~/context/shopify';
import { formatPrice } from '~/utils/currencyFormatting';

import { SummaryProps } from './models';

const Summary: FC<SummaryProps> = ({
  subtotalLabel,
  subtotalLabelUI,
  totalLabel,
  totalLabelUI,
  informationLabel,
  informationLabelUI,
  totalAmountLabel,
  totalAmountLabelUI,
  checkoutButton,
  handleCheckout,
  discountCode,
}) => {
  const { checkout } = useContext(StoreContext);

  const totalPriceBeforeDiscount = checkout.lineItems.reduce(
    (total, { quantity, variant: { compareAtPriceV2, priceV2 } }) => {
      const priceAmount = parseFloat(
        compareAtPriceV2?.amount || priceV2.amount
      );

      return total + quantity * priceAmount;
    },
    0
  );

  const totalPriceAfterDiscount = Number(checkout.totalPriceV2.amount);

  const isPriceDiscounted =
    totalPriceAfterDiscount !== totalPriceBeforeDiscount;

  const { currencyCode } = checkout.totalPriceV2;

  return (
    <div className="shopping-cart__summary-and-payment">
      <div className="shopping-cart__summary">
        <Typography
          {...totalLabelUI}
          content={totalLabel}
          className="shopping-cart__summary-heading"
        />
        <div className="shopping-cart__summary-block">
          <Typography
            {...subtotalLabelUI}
            content={subtotalLabel}
            className="shopping-cart__summary-title"
          />
          <div className="shopping-cart__summary-price-block">
            {isPriceDiscounted ? (
              <Typography
                className="shopping-cart__summary-price-old"
                content={formatPrice(currencyCode, totalPriceBeforeDiscount)}
                variant="body"
                size="xs"
                weight="light"
              />
            ) : null}
            <Typography
              className="shopping-cart__summary-price"
              content={formatPrice(currencyCode, totalPriceAfterDiscount)}
              variant="body"
            />
          </div>
        </div>
        <Typography
          {...informationLabelUI}
          content={informationLabel}
          className="shopping-cart__summary-info"
        />
        <hr />
        <DiscountCode discountCode={discountCode} />
        <hr />
        <div className="shopping-cart__summary-block-total">
          <Typography
            {...totalAmountLabelUI}
            content={totalAmountLabel}
            className="shopping-cart__summary-title-total"
          />
          <Typography
            className="shopping-cart__summary-price-total"
            content={formatPrice(currencyCode, totalPriceAfterDiscount)}
            variant="body"
            size="xl"
            weight="bold"
          />
        </div>
        <Button
          {...checkoutButton}
          className="shopping-cart__summary-button"
          onClick={handleCheckout}
        >
          {checkoutButton.children}
        </Button>
      </div>
    </div>
  );
};

export default Summary;
